import { useEffect } from "react";

type Props = {
  themeMode: "dark" | "light" | null;
};

const ThemeInitializer = ({ themeMode }: Props) => {
  useEffect(() => {
    if (!themeMode) return;

    const root = document.documentElement;
    root.classList.remove("dark", "light");
    root.classList.add(themeMode);
  }, [themeMode]);

  return null;
};

export default ThemeInitializer;
